import { render, staticRenderFns } from "./AddPricing.vue?vue&type=template&id=ef406f3c&scoped=true&"
import script from "./AddPricing.vue?vue&type=script&lang=js&"
export * from "./AddPricing.vue?vue&type=script&lang=js&"
import style0 from "./AddPricing.vue?vue&type=style&index=0&id=ef406f3c&lang=scss&scoped=true&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef406f3c",
  null
  
)

export default component.exports